import { render, staticRenderFns } from "./ProductSpecification.vue?vue&type=template&id=b521cf90&scoped=true&"
import script from "./ProductSpecification.vue?vue&type=script&lang=js&"
export * from "./ProductSpecification.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecification.vue?vue&type=style&index=0&id=b521cf90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b521cf90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b521cf90', component.options)
    } else {
      api.reload('b521cf90', component.options)
    }
    module.hot.accept("./ProductSpecification.vue?vue&type=template&id=b521cf90&scoped=true&", function () {
      api.rerender('b521cf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ProductSpecification.vue"
export default component.exports